import React, { useEffect, useState } from 'react';
import { Button, Col, Drawer, FlexboxGrid, Input, Message, Modal, Panel, SelectPicker, Stack, useToaster, Form } from 'rsuite';
import PageNextIcon from '@rsuite/icons/PageNext';
import MoveUpIcon from '@rsuite/icons/MoveUp';
import CopyIcon from '@rsuite/icons/Copy';
import DataAuthorizeIcon from '@rsuite/icons/DataAuthorize';
import GenearateAuthSliderUpdate from './GenerateAuthSliderUpdate';
import axios from 'axios';
import globalIP from '@/GlobelIP';
import {Link, useNavigate } from 'react-router-dom';
import CopyCatalogue from './CopyCatalogue';
import ugr from '@/UGRoute';
import { values } from 'lodash';
import { Icon } from '@rsuite/icons';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import useUser from '../../components/UseUser';
type YourDataType = {
  id: number;
  attributes: {
    CoverImage: any;
    ProductName: string;
    ProductId: string;
    ProductType: string;
    SizeUnit: string;
    Length: number;
    Width: number;
    Color: string;
    Finish: string;
    SellingPrice: number;
    MOQ: number;
    // Add other attribute properties here
  };
};
let catalogueCodeCounter = 1;
export default function ManageCatalogueSlider({
  open,
  close,
  editData,
  handleTrashRow,
  setCatalogueData,
  setReload,
}) {
  const {user} = useUser();
  const [updateGenerateAuthSlider, setUpdateGenerateAuthSlider] = useState(false);
  const [copyDataModal, setCopyDataModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [qtnModal , setQtnModal] = useState(false)

  const navigate = useNavigate();
  const toaster = useToaster();
  const CheckCredentials = (message: string, type?: string) => {
    toaster.push(
      <Message showIcon type={type}>
        {message}
      </Message>,
      { placement: 'topCenter' }
    );
  };
  const UpdateCatalogStatus = async () => {
    try {
      if (editData.attributes.Status == 'Active') {
        const {
          data: { data }
        } = await axios.put(`${globalIP}/api/catalogues/${editData.id}`, {
          data: { Status: 'inActive' }
        });

        if (data) {
          CheckCredentials('Catalog link successfully updated', 'success');
          close();
          setReload(prev => !prev);
        } else {
          CheckCredentials('Failed to update catalog link', 'error');
        }
      } else {
        CheckCredentials('Already updated catalog link status', 'error');
      }
    } catch (error) {
      console.error('Error updating catalog status:', error);
      CheckCredentials('An error occurred while updating catalog status', 'error');
    }
  };

  const data = [
    {
      icon: <MoveUpIcon />,
      title: 'Create Quotation',
      para: 'You can maintain a list of all quotations generated against buyer. ',
      click: () => setQtnModal(true),
      // disabled: ()=>{!isDataFetched}
    },
    (user.CATModifySts || user.Category === 'Admin') && {
      icon: <MoveUpIcon />,
      title: 'Deactivate catalogue link',
      para: 'Link will be deactivated and you can activate it again later.',
      click: () => UpdateCatalogStatus()
    },
    (user.CATLinkSecurity || user.Category === 'Admin' || editData?.attributes?.Glink ) && {
      icon: <DataAuthorizeIcon style={{ fontSize: '20px' }} />,
      title: 'Update link settings',
      para: 'Change settings for password security and expiry date.',
      click: () => setUpdateGenerateAuthSlider(true)
    },
   {
      icon: <CopyIcon style={{ fontSize: '20px' }} />,
      title: 'Create a copy of this catalogue ',
      para: 'A copy of this catalogue will be created will be created with same products.',
      click: () => setCopyDataModal(true)
    },
    {
      icon: <MoveUpIcon style={{ fontSize: '20px' }} />,
      title: 'Change PPT template',
      para: 'Set the template of the PPT when buyer downloads from link.',
      click: () => navigate(`/${ugr}/templates`) 
    },
    (user.CATDelete || user.Category === 'Admin') && {
      icon: <MoveUpIcon style={{ fontSize: '20px' }} />,
      title: 'Delete this catalogue',
      para: 'Permanently delete this catalogue. You cannot restore them later.',
      click: () => setDeleteModal(true)
    }
  ].filter(Boolean);


const [selectedBuyer, setSelectedBuyer] = React.useState([]);
const [loading, setLoading] = useState(true);
const [open4, setOpen4] = React.useState(false);
const handleOpen4 = () => setOpen4(true);
const handleClose4 = () => setOpen4(false);
const [open2, setOpen2] = React.useState(false);
const handleOpen2 = () => setOpen2(true);
const handleClose2 = () => {
  setOpen2(false);
};

const [companydataa , setCompanydataa] = useState([])
const [selectedCompany, setSelectedCompany] = useState(null);
useEffect(() => {
  fetchData6();
}, []);

const fetchData6 = async () => {
  try {
    const response = await fetch(`${globalIP}/api/buyer-companies`);
    const json = await response.json();
    const processedData = json.data.map(item => ({
      label: item.attributes.companynm,
      value: item.attributes.companynm
    }));
    setCompanydataa(processedData);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};
const [buyeerdata, setBuyeerdata] = React.useState([]);
const buyeerdata1 = [];
useEffect(() => {
  fetchData3();
}, []);
const fetchData3 = async () => {
  try {
    const response = await fetch(`${globalIP}/api/buyer-details`);
    const json = await response.json();
    const processedData = json.data.map(item => ({
      label: item.attributes.buyernm,
      value: item.attributes.buyercode,
      company: item.attributes.companynm
    }));
    setBuyeerdata(processedData);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const filteredBuyerData = selectedCompany
  ? buyeerdata.filter(item => item.company === selectedCompany)
  : buyeerdata1;


const [qut, setQut] = useState({
  QuotationName: '',
  Q_BuyerCompany: '',
  Q_BuyerEmail: '',
  QuotationCode: '',
  Q_BuyerName: '',
  Q_Status: 'Active',
  QuotationProduct: [
    {
      QuotationProductcode: '',
      QuotationCode: '',
      Price: 0,
      MOQ: 0
    }
  ]
});


const generateCatalogue = () => {
  const categoryCount = qutadata.length;
  const nextCode = categoryCount + 1;
  return `QUOT-${nextCode.toString().padStart(3, '0')}`;
};
const [qutadata, setQutadata] = React.useState([]);
  useEffect(() => {
    fetchData0();
  }, []);
  const fetchData0 = async () => {
    const response = await fetch(`${globalIP}/api/quotations`);
    const json = await response.json();
    setQutadata(json.data);
  };

const handleInputChange = (inputName, event, index) => {
  const value = event.target ? event.target.value : event;
  if (inputName == 'Q_BuyerCompany') {
    setSelectedCompany(value);
  }
  if (inputName == 'Q_BuyerName') {
    setSelectedBuyer(value);
  }

  setQut({ ...qut, [inputName]: value });
};
const datattt = () => {
  if (qut.QuotationName === '') {
    toaster.push(
      <Message showIcon type="error">
        Please Enter Catalogue Name
      </Message>,
      { placement: 'topEnd' }
    );
  } else {
    submit(event);
  }
};
const[productvaridss , setProductvaridss] = useState([])
useEffect(() => {
  fetchData();
}, []);

const fetchData = async () => {

  const productvarids = Array.isArray(editData.attributes.CatalogueProduct)
    ? editData.attributes.CatalogueProduct
    : [editData.attributes.CatalogueProduct]; // Ensure it's an array

  setProductvaridss(productvarids)
  setLoading(true);
  
  const allSelectedItems = [];
  for (let productvaridss of productvarids) {
    for (let page = 1; ; page++) {
      const response = await fetch(
        `${globalIP}/api/products?${productvaridss}&populate=*&pagination[page]=${page}`
      );
      const json = await response.json();
      if (json.data.length === 0) break; 
      allSelectedItems.push(...json.data);
      if (page >= json.meta.pagination.pageCount) break; 
    }
  }
  
  setLoading(false);
};


const url2 =` ${globalIP}/api/quotations`;
const submit = e => {
  e.preventDefault();

  if (qut.QuotationName === '') {
    toaster.push(
      <Message showIcon type="error">
        Please Enter Quotation Name
      </Message>,
      { placement: 'topEnd' }
    );
    return;
  }

  const nextCatalogueCode = generateCatalogue();
  const formData = new FormData();

  if (!Array.isArray(productvaridss) || productvaridss.length === 0) {
    console.error("Invalid or empty productvarids array");
    return;
  }
  const selectedProducts = productvaridss.map(item => ({
    id: item.id,  // Handle null safety
    QuotationProductcode: item.CatalogProduct,
    QuotationCode: nextCatalogueCode
  }));

  const updatedCatalogue = {
    ...qut,
    QuotationCode: nextCatalogueCode,
    QuotationProduct: selectedProducts
  };

  formData.append('data', JSON.stringify(updatedCatalogue));

  fetch(url2, {
    method: 'POST',
    body: formData
  })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      handleClose2();
      handleOpen4();
    })
    .catch(error => console.error(error));

  catalogueCodeCounter++;
};

  return (
    <>
      <Drawer open={open} onClose={close} size="xs" backdrop="static">
        <Drawer.Header>
          <Drawer.Title>
            <h5>Catalogue Settings</h5>
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          {data.map(item => {
            return (
              <Panel
                shaded
                key={item.title}
                style={{ marginBottom: '10px', padding: '10px 0', cursor: 'pointer' }}
                onClick={item.click}
              >
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div>{item.icon}</div>
                  <div>
                    <h6
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '5px'
                      }}
                    >
                      <span>{item.title}</span> <PageNextIcon style={{ fontSize: '20px' }} />
                    </h6>
                    <span style={{ color: 'grey', fontSize: '12px' }}>{item.para}</span>
                  </div>
                </div>
              </Panel>
            );
          })}
        </Drawer.Body>
      </Drawer>
      {updateGenerateAuthSlider && (
        <GenearateAuthSliderUpdate
          open={updateGenerateAuthSlider}
          close={() => {
            setUpdateGenerateAuthSlider(false);
            close();
          }}
          editData={editData}
        />
      )}
      {
        <CopyCatalogue
          open={copyDataModal}
          close={() => {
            setCopyDataModal(false);
            close();
          }}
          allData={editData}
          CheckCredentials={CheckCredentials}
          setCatalogueData2={setCatalogueData}
        />
      }


<Modal open={qtnModal} onClose={() => setQtnModal(false)} backdrop={'static'} size="lg">
          <Modal.Header>
            <b>Please fill the Quotation details.</b>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Quotation Name </p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      id="QuotationName"
                      name="QuotationName"
                      value={qut && qut.QuotationName ? qut.QuotationName : ''}
                      onChange={value => handleInputChange('QuotationName', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                    <SelectPicker
                      data={companydataa}
                      labelKey="label"
                      valueKey="value"
                      id="Q_BuyerCompany"
                      name="Q_BuyerCompany"
                      value={qut && qut.Q_BuyerCompany ? qut.Q_BuyerCompany : ''}
                      onChange={value => handleInputChange('Q_BuyerCompany', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                    <SelectPicker
                      data={filteredBuyerData}
                      labelKey="label"
                      valueKey="value"
                      id="Q_BuyerName"
                      name="Q_BuyerName"
                      value={qut && qut.Q_BuyerName ? qut.Q_BuyerName : ''}
                      onChange={value => handleInputChange('Q_BuyerName', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="email-1">
                    <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                    <Input
                      id="Q_BuyerEmail"
                      name="Q_BuyerEmail"
                      value={qut && qut.Q_BuyerEmail ? qut.Q_BuyerEmail : ''}
                      onChange={value => handleInputChange('Q_BuyerEmail', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end">
              <Button 
              onClick={datattt} 
              appearance="primary" color="cyan">
                Finish
              </Button>
            </Stack>
          </Modal.Footer>
        
      </Modal>
      <Modal open={open4} onClose={handleClose4} backdrop="static">
          <Modal.Header>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Stack direction="column">
              <Icon
                as={CheckOutlineIcon}
                color="cyan"
                style={{ fontSize: '100px', marginBottom: '20px' }}
              />
              <b>Saved Successfully</b>
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            <Stack spacing={15} alignItems="flex-end" justifyContent="flex-end">
              <Link to={`/${ugr}/manageOrdQ`}>
                <Button appearance="subtle" active>
                  Manage Quotation
                </Button>
              </Link>
              <Link to={`/${ugr}/selectionQ`}>
                <Button appearance="primary" color="cyan">
                  Ok
                </Button>
              </Link>
            </Stack>
          </Modal.Footer>
        </Modal>
        
      <Modal open={deleteModal} onClose={() => setDeleteModal(false)} size="xs" backdrop='static'>
        <Modal.Body>
          <Message showIcon type="warning" header="Delete Catalogue">
            Are you sure you want to delete this catalogue? This action cannot be undone.
          </Message>

        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => {
            handleTrashRow(editData.id); // Call the delete function passed as a prop
            setDeleteModal(false);
            close();
          }} appearance='primary' color='cyan' size='sm'>
            Delete
          </Button>
          <Button onClick={() => setDeleteModal(false)} appearance="subtle" active size='sm'>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function fetchBuyerData() {
  throw new Error('Function not implemented.');
}

